import * as types from '../types.js'

const initPageState = () => {
  return {
    // 搜索model
    model: {name: "", areaId: "", floor: 0, parent: {name: "", pid: ""}},
    // 当前请求的日期
    date: new Date(),
    firstAreas: [],
    departObject: {departName: "", departId: '', belongToId: ""},
    xid: ""
  }
};
const index = {
  state: initPageState(),
  mutations: {
    [types.SAVE_MEAL_MODEL](state, pageState) {
      for (let prop in pageState) {
        state[prop] = pageState[prop]
      }
    },
    [types.SAVE_MEAL_DATE](state, pageState) {
      for (let prop in pageState) {
        state[prop] = pageState[prop]
      }
    },
    [types.SAVE_MEAL_FIRST_AREAS](state, pageState) {
      for (let prop in pageState) {
        state[prop] = pageState[prop]
      }
    },
    [types.SAVE_MEAL_DEPART_OBJECT](state, pageState) {
      for (let prop in pageState) {
        state[prop] = pageState[prop]
      }
    },
    [types.SAVE_MEAL_XID](state, pageState) {
      for (let prop in pageState) {
        state[prop] = pageState[prop]
      }
    }
  },
  actions: {}
};

export default index



// WEBPACK FOOTER //
// ./src/store/app/modules/setMeal.js